module.exports = __webpack_public_path__ + "img/login-illustration.63d349a9.png";